import { useIoContext, useStoreActions } from "../../../../contexts";
import { jsx as _jsx } from "react/jsx-runtime";
export function TutorialVideosPlayedVideo(_ref) {
  let {
    video,
    onWatch
  } = _ref;
  const {
    YoutubePlayer
  } = useIoContext();
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/_jsx(YoutubePlayer, {
    width: "none",
    height: "none",
    controls: true,
    url: "https://youtu.be/".concat(video.id),
    "data-testid": "tutorial-played-video",
    onStart: () => {
      if (!video.watched) {
        onWatch(video);
      }
      logBI(11215, {
        videoId: video.id,
        title: video.title
      });
    }
  });
}